if (!customElements.get('cb-collection-description')) {
  customElements.define('cb-collection-description', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.body = this.querySelector('.cb-collection-description__body');
      this.button = this.querySelector('button');
      this.dataset.expanded = 'false';
      this.button.addEventListener('click', () => {
        const expanded = this.dataset.expanded !== 'true';
        this.dataset.expanded = String(expanded);
        this.button.setAttribute('aria-expanded', String(expanded));
        this.button.textContent = expanded ? 'Arată mai puțin' : 'Citește mai mult';
      });
      this.observer = new ResizeObserver(() => {
        this.button.hidden = this.body.scrollHeight <= 150;
      });
      this.observer.observe(this.body);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.ready = false;
    }
  });
}
